import { render, staticRenderFns } from "./thaicuisine.vue?vue&type=template&id=aa846686&scoped=true"
import script from "./thaicuisine.vue?vue&type=script&lang=js"
export * from "./thaicuisine.vue?vue&type=script&lang=js"
import style0 from "./thaicuisine.vue?vue&type=style&index=0&id=aa846686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa846686",
  null
  
)

export default component.exports